import { useCallback, useLayoutEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';

/**
 * Altera a query string partindo SEMPRE dos parâmetros mais recentes. A forma funcional do
 * `setSearchParams` recebe os parâmetros da renderização em que foi criada — um filtro aplicado
 * depois de um atraso (busca) apagava o `doc` que a pessoa tinha acabado de abrir (achado no E2E).
 */
export function useAtualizarUrl() {
  const [params, setParams] = useSearchParams();
  const atuais = useRef(params);
  // Sincroniza depois de cada renderização e antes de qualquer timer (busca com atraso).
  useLayoutEffect(() => {
    atuais.current = params;
  }, [params]);
  const atualizar = useCallback(
    (mudar: (proximo: URLSearchParams) => void, opcoes?: { replace?: boolean }) => {
      const proximo = new URLSearchParams(atuais.current);
      mudar(proximo);
      atuais.current = proximo;
      setParams(proximo, opcoes);
    },
    [setParams],
  );
  return { params, atualizar };
}
